export default "__VITE_ASSET__QIDQDnue__"